export default "__VITE_ASSET__m8ZVJMa9R0xp1E9MHm5YNg__"